import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { playAlarm, primeAudio, repeatMsForLevel } from "@/lib/alarmSound";

export const alarmLevel = (event) => Math.min(event?.escalation_level || 0, 2);

export function useDueReminder() {
  const [event, setEvent] = useState(null);
  const soundTimer = useRef(null);
  const lastId = useRef(null);
  const ignored = useRef(new Set());

  useEffect(() => {
    const poll = async () => {
      try {
        const r = await api.get("/reminders/due");
        setEvent(r.data.events.find((e) => !ignored.current.has(e.id)) || null);
      } catch (e) {
        if (e?.response?.status !== 401) console.warn("Reminder poll failed", e?.message);
      }
    };
    const prime = () => primeAudio();
    window.addEventListener("pointerdown", prime, { once: true });
    poll();
    const t = setInterval(poll, 20000);
    return () => { clearInterval(t); window.removeEventListener("pointerdown", prime); };
  }, []);

  useEffect(() => {
    clearInterval(soundTimer.current);
    if (!event) return;
    const level = alarmLevel(event);
    const key = `${event.id}-${event.escalation_level}`;
    if (lastId.current !== key) {
      lastId.current = key;
      playAlarm(level);
    }
    soundTimer.current = setInterval(() => playAlarm(level), repeatMsForLevel(level));
    return () => clearInterval(soundTimer.current);
  }, [event]);

  /** Hide this alarm for the rest of the session even if the server call failed. */
  const hide = (id) => { ignored.current.add(id); setEvent(null); };

  return [event, setEvent, hide];
}
